module.exports = __webpack_public_path__ + "static/media/pc-BudgetTracker.5117a5da.jpg";